import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {IDialogComponent} from "../../dialog/iDialog.component";
import {DialogWithInput} from "../../dialog/dialogWithInput";
import {DialogModule} from "../../dialog/dialog.module";
import {VideoRecorderComponent} from "../video-recorder/video-recorder.component";

export interface VideoRecorderDialogOutput {
  blob: Blob;
}

@Component({
  selector: 'app-video-recorder-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, VideoRecorderComponent],
  templateUrl: './video-recorder-dialog.component.html',
  styles: [
  ]
})
export class VideoRecorderDialogComponent implements IDialogComponent<void, VideoRecorderDialogOutput> {
  dialog: DialogWithInput<void, VideoRecorderDialogOutput>;

}
